export const useFetchMember = async () => {
  const route = useRoute()
  const { locale } = useI18n()

  const fetchMember = async (additional = '') => {
    return await useAsyncData(
      async () => {
        const response = await $fetch(
          '/api/v1/contentful/investor/corporate-governance/board-members/member',
          {
            query: {
              locale: locale.value,
              slug: `${additional}${route.params.member}` || '',
            },
          },
        )
        
        return response?.member ?? null
      })
  }

  return { fetchMember }
}
